import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/adbazaar/campaigns{/action}{/itemId}`,
  {},
  {
    updateCampaign: { method: 'PATCH' },
    saveCSV: { method: 'GET', params: { action: 'export' } },
    getOverview: {
      method: 'GET',
      params: { action: 'overview' },
    },
  },
);
